const logRequestsEnabled = false

export const queryIsEnabled = (condition = false) => !!condition

/**
 * @errorType {string} throw|reject_with_throw|reject_with_message
 * @errorMessage {string} The error message to display
 **/
function errorHandler({ errorType = 'throw', errorMessage }) {
  switch (errorType) {
    case 'throw':
      throw new Error(errorMessage)

    case 'reject_with_throw':
      return Promise.reject(new Error(errorMessage))

    case 'reject_with_message':
    default:
      return Promise.reject({ name: 'Error', message: errorMessage })
  }
}

const defaultHeaders = new Headers({
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private',
  Pragma: 'no-cache',
  Expires: 0,
})

const processSearchParams = params => {
  let queryString = ''
  if (Object.keys(params).length > 0) {
    queryString = `?${Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&')}`
  }
  return queryString
}

function logRequest({ msg, data }) {
  if (logRequestsEnabled) {
    console.log(msg, data)
  }
}

export const getRequest = async ({
  url,
  params = {},
  credentials = 'include',
  headers = defaultHeaders,
  signal,
  errorType = 'reject_with_message',
  errorMessage = 'Error fetching data. Please try again later.',
}) => {
  logRequest({ msg: `*** GET received params for ${url}:`, data: params })
  const searchParams = new URLSearchParams(params)
  const searchParamsString = searchParams.toString()
  logRequest({ msg: `*** GET Search Params string for ${url}:`, data: searchParamsString })
  const request = new Request(`${url}${searchParamsString ? `?${searchParamsString}` : ''}`, {
    method: 'GET',
    headers,
    credentials,
  })
  const response = await fetch(request, { signal })
  if (response.ok) {
    return response.json()
  }
  return errorHandler({ errorType, errorMessage })
}

export const postRequest = async ({
  url,
  params = {},
  payload,
  headers = defaultHeaders,
  signal,
  errorType = 'reject_with_message',
  errorMessage = 'Error submitting data. Please try again later.',
}) => {
  logRequest({ msg: `*** POST received params for ${url}:`, data: params })
  const searchParams = new URLSearchParams(params)
  const searchParamsString = searchParams.toString()
  logRequest({ msg: `*** POST Search Params string for ${url}:`, data: searchParamsString })
  const request = new Request(`${url}${searchParamsString ? `?${searchParamsString}` : ''}`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(payload), // payload should be an object
  })
  const response = await fetch(request, { signal })
  if (response.ok) {
    return response.json()
  }
  return errorHandler({ errorType, errorMessage })
}

export const putRequest = async ({
  url,
  params = {},
  payload,
  headers = defaultHeaders,
  signal,
  errorType = 'reject_with_message',
  errorMessage = 'Error submitting data. Please try again later.',
}) => {
  logRequest({ msg: `*** PUT received params for ${url}:`, data: params })
  const searchParams = new URLSearchParams(params)
  const searchParamsString = searchParams.toString()
  logRequest({ msg: `*** PUT Search Params string for ${url}:`, data: searchParamsString })
  const request = new Request(`${url}${searchParamsString ? `?${searchParamsString}` : ''}`, {
    method: 'PUT',
    headers,
    credentials: 'include',
    body: JSON.stringify(payload), // payload should be an object
  })
  const response = await fetch(request, { signal })
  if (response.ok) {
    return response.json()
  }
  return errorHandler({ errorType, errorMessage })
}

export const deleteRequest = async ({
  url,
  params = {},
  headers = defaultHeaders,
  signal,
  errorType = 'reject_with_message',
  errorMessage = 'Error deleting data. Please try again later.',
}) => {
  logRequest({ msg: `*** DELETE received params for ${url}:`, data: params })
  const searchParams = new URLSearchParams(params)
  const searchParamsString = searchParams.toString()
  logRequest({ msg: `*** DELETE Search Params string for ${url}:`, data: searchParamsString })
  const request = new Request(`${url}${searchParamsString ? `?${searchParamsString}` : ''}`, {
    method: 'DELETE',
    headers,
    credentials: 'include',
  })
  const response = await fetch(request, { signal })
  if (response.ok) {
    return response.json()
  }
  return errorHandler({ errorType, errorMessage })
}
